module.exports = __webpack_public_path__ + "img/5天通道.cbf5aa71.png";